import { render } from "./DRsimulationTestModal.vue?vue&type=template&id=24c685d1&scoped=true"
import script from "./DRsimulationTestModal.vue?vue&type=script&lang=js"
export * from "./DRsimulationTestModal.vue?vue&type=script&lang=js"

import "./DRsimulationTestModal.vue?vue&type=style&index=0&id=24c685d1&scoped=true&lang=scss"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c685d1"]])

export default __exports__